import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import type { DistanceUnit } from '../types/models';

export async function ensureDistanceUnit(uid: string): Promise<void> {
  const ref = doc(db, 'users', uid);
  const snap = await getDoc(ref);
  if (!snap.exists()) return;

  const data = snap.data();
  if (!data.distanceUnit) {
    await updateDoc(ref, {
      distanceUnit: 'km',
      updatedAt: new Date().toISOString(),
    });
  }
}

export async function updateUserDistanceUnit(uid: string, unit: DistanceUnit): Promise<void> {
  const ref = doc(db, 'users', uid);
  await setDoc(
    ref,
    {
      distanceUnit: unit,
      updatedAt: new Date().toISOString(),
    },
    { merge: true }
  );
}

export async function getUserProfile(uid: string) {
  const ref = doc(db, 'users', uid);
  const snap = await getDoc(ref);
  return snap.exists() ? snap.data() : null;
}
